var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookF(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M17.5858 2.00437L14.9474 2C11.9832 2 10.0677 4.02849 10.0677 7.16813V9.55098H7.41486C7.18563 9.55098 7 9.7428 7 9.9794V13.4319C7 13.6685 7.18584 13.8601 7.41486 13.8601H10.0677V22.5718C10.0677 22.8084 10.2533 23 10.4825 23H13.9437C14.1729 23 14.3585 22.8082 14.3585 22.5718V13.8601H17.4603C17.6895 13.8601 17.8751 13.6685 17.8751 13.4319L17.8764 9.9794C17.8764 9.8658 17.8326 9.757 17.7549 9.6766C17.6772 9.5962 17.5714 9.55098 17.4613 9.55098H14.3585V7.53101C14.3585 6.56013 14.5827 6.06726 15.808 6.06726L17.5853 6.0666C17.8144 6.0666 18 5.87479 18 5.6384V2.43257C18 2.1964 17.8146 2.00481 17.5858 2.00437Z"
  })));
}

export default SvgFacebookF;